<template>
	<div class="tab-container" v-if="active" :style="{padding:padding+'px'}">
		<slot></slot>
	</div>
</template>
<script>
	export default {
	    name: 'tab',
	    props: {
	    	padding:{
	    		type:Number,
	    		default:8
	    	},
	        title: {
	            type: String,
	            default: 'Title'
	        },
	        icon: {
	            type: String,
	            default: ''
	        },
	        /***
	         * Function to execute before tab switch. Return value must be boolean
	         * If the return result is false, tab switch is restricted
	         */
	        beforeChange: {
	            type: Function
	        },
	        id: String,
	        route: {
	            type: [String, Object]
	        },
	        transitionName: String,
	        transitionMode: String
	    },
	    computed: {
	        isValidParent: function isValidParent() {
	            return this.$parent.$options.name === 'vue-tabs';
	        },
	        hash: function hash() {
	            return '#' + this.id;
	        }
	    },
	    data: function data() {
	        return {
	            active: false,
	            validationError: null
	        };
	    },
	    mounted: function mounted() {
	        this.$parent.addTab(this);
	    },
	    destroyed: function destroyed() {
	        if (this.$el && this.$el.parentNode) {
	            this.$el.parentNode.removeChild(this.$el);
	        }
	        this.$parent.removeTab(this);
	    }
};
</script>
<style scoped>
	.tab{
		font-size:24px;
		color:red;
	}
</style>